import * as React from "react";
import { render } from "react-dom";
import assertContainerElement from "Utils/assertContainerElement";
import Pricing from "./PricingPage";

const root = document.getElementById("pricing-page");
assertContainerElement(root);
render(<Pricing />, root);